import type { Field, OfficeRecord } from "@types";
import {
  AIRTABLE_BASE_CAMPAIGN_EN,
  AIRTABLE_BASE_CAMPAIGN_FR,
  AIRTABLE_BASE_CAMPAIGN_NL,
  AIRTABLE_BASE_JOBS_EN,
  AIRTABLE_BASE_JOBS_FR,
  AIRTABLE_BASE_JOBS_NL,
  AIRTABLE_BASE_PARTNERS_EN,
  AIRTABLE_BASE_PARTNERS_FR,
  AIRTABLE_BASE_PARTNERS_NL,
  AIRTABLE_GENERAL_FORM,
  FormType,
  getCampaignFormFieldsEN,
  getCampaignFormFieldsFR,
  getCampaignFormFieldsNL,
  getContactFormFields,
  JOBS_CONTACT_FORM_FIELDS_EN,
  JOBS_CONTACT_FORM_FIELDS_FR,
  JOBS_CONTACT_FORM_FIELDS_NL,
  PARTNER_CONTACT_FORM_FIELDS_EN,
  PARTNER_CONTACT_FORM_FIELDS_FR,
  PARTNER_CONTACT_FORM_FIELDS_NL,
} from "consts";
import { getPublicLocale, type Locale } from "consts/locale";

export const getFormFields = ({
  formType,
  locale,
  offices,
  dates,
  disablePartnershipEnterprise,
  t,
}: {
  formType: FormType;
  locale: Locale;
  offices?: OfficeRecord[];
  dates?: { date: string }[];
  disablePartnershipEnterprise?: boolean;
  t?: (key: string) => string;
}): Field[] | undefined => {
  const publicLocale = getPublicLocale(locale);

  if (formType === FormType.general) {
    return getContactFormFields(offices, t);
  }

  if (formType === FormType.jobs && publicLocale === "nl") {
    return JOBS_CONTACT_FORM_FIELDS_NL;
  }
  if (formType === FormType.jobs && publicLocale === "fr") {
    return JOBS_CONTACT_FORM_FIELDS_FR;
  }
  if (formType === FormType.jobs && publicLocale === "en") {
    return JOBS_CONTACT_FORM_FIELDS_EN;
  }

  if (formType === FormType.partners && publicLocale === "nl") {
    return PARTNER_CONTACT_FORM_FIELDS_NL;
  }
  if (formType === FormType.partners && publicLocale === "fr") {
    return PARTNER_CONTACT_FORM_FIELDS_FR;
  }
  if (formType === FormType.partners && publicLocale === "en") {
    return PARTNER_CONTACT_FORM_FIELDS_EN;
  }

  if (formType === FormType.campaign && publicLocale === "nl") {
    return getCampaignFormFieldsNL(dates, disablePartnershipEnterprise);
  }
  if (formType === FormType.campaign && publicLocale === "fr") {
    return getCampaignFormFieldsFR(dates, disablePartnershipEnterprise);
  }
  if (formType === FormType.campaign && publicLocale === "en") {
    return getCampaignFormFieldsEN(dates, disablePartnershipEnterprise);
  }

  return undefined;
};

export const getAirtableFormBase = (formType: FormType, locale: Locale): string => {
  const publicLocale = getPublicLocale(locale);

  if (formType === FormType.general) {
    return AIRTABLE_GENERAL_FORM;
  }

  if (formType === FormType.jobs && publicLocale === "nl") {
    return AIRTABLE_BASE_JOBS_NL;
  }
  if (formType === FormType.jobs && publicLocale === "fr") {
    return AIRTABLE_BASE_JOBS_FR;
  }
  if (formType === FormType.jobs && publicLocale === "en") {
    return AIRTABLE_BASE_JOBS_EN;
  }

  if (formType === FormType.partners && publicLocale === "nl") {
    return AIRTABLE_BASE_PARTNERS_NL;
  }
  if (formType === FormType.partners && publicLocale === "fr") {
    return AIRTABLE_BASE_PARTNERS_FR;
  }
  if (formType === FormType.partners && publicLocale === "en") {
    return AIRTABLE_BASE_PARTNERS_EN;
  }

  if (formType === FormType.campaign && publicLocale === "nl") {
    return AIRTABLE_BASE_CAMPAIGN_NL;
  }
  if (formType === FormType.campaign && publicLocale === "fr") {
    return AIRTABLE_BASE_CAMPAIGN_FR;
  }
  if (formType === FormType.campaign && publicLocale === "en") {
    return AIRTABLE_BASE_CAMPAIGN_EN;
  }

  return AIRTABLE_GENERAL_FORM;
};
